

export function compareTabInit() {
    let tabElList = document.querySelectorAll('#compareTab a[data-bs-toggle="tab"]')
    tabElList.forEach(async tabEl => {
        tabEl.addEventListener('shown.bs.tab', async () => {
            const dropdownCompare = document.getElementById('js-compare-dropdown');

            if (dropdownCompare) {
                dropdownCompare.innerText = tabEl.textContent;
            }

            const tabPaneTarget = tabEl.getAttribute('href');
            const tabPane = document.querySelector(tabPaneTarget);

            if (tabPane) {
                const {getMaxHeight, updateHeight} = await import('../../sameHeight');
                const propertyCount = tabPane.getAttribute('data-properties');

                for (let i = 1; i <= parseInt(propertyCount); i++) {
                    const values = tabPane.querySelectorAll('.js-compare-value[data-property="' + i + '"]');
                    const property = tabPane.querySelectorAll('.js-compare-property[data-property="' + i + '"]');

                    let itemsMaxHeight = getMaxHeight(values);

                    updateHeight(values, itemsMaxHeight);
                    updateHeight(property, itemsMaxHeight);
                }
            }
        })
    });
}